import { KeyboardEvent } from 'react';
import { Button } from '@/components/ui/Button';
import { Textarea } from '@/components/ui/Textarea';

interface ComposerInputProps {
  value: string;
  placeholder: string;
  disabled?: boolean;
  loading?: boolean;
  onChange: (value: string) => void;
  onSubmit: () => void;
  /** While Domino answers: stops the turn for real (its model call is cancelled).
   * Leaving the page never stops it. */
  onStop?: () => void;
  stopping?: boolean;
}

export const ComposerInput = ({
  value,
  placeholder,
  disabled = false,
  loading = false,
  onChange,
  onSubmit,
  onStop,
  stopping = false,
}: ComposerInputProps) => {
  const handleKeyDown = (event: KeyboardEvent<HTMLTextAreaElement>) => {
    if (event.key !== 'Enter') return;
    if (event.shiftKey) return;
    event.preventDefault();
    if (!value.trim() || disabled || loading) return;
    onSubmit();
  };

  return (
    <div className="border-t border-gray-200 bg-white p-4">
      <div className="rounded-2xl border border-gray-300 bg-white p-3 shadow-sm">
        <Textarea
          value={value}
          onChange={(event) => onChange(event.target.value)}
          onKeyDown={handleKeyDown}
          rows={3}
          disabled={disabled}
          placeholder={placeholder}
          className="min-h-[88px] border-0 p-0 shadow-none focus-visible:ring-0"
        />
        <div className="mt-3 flex justify-end">
          {loading && onStop ? (
            <Button variant="secondary" onClick={onStop} loading={stopping}>
              Arrêter
            </Button>
          ) : (
            <Button
              onClick={onSubmit}
              disabled={!value.trim() || disabled}
              loading={loading}
            >
              Envoyer
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

